import { useLinesVodGenresStore } from "@/stores/LinesVodGenres";

const {
	setShowAllMovies
} = useLinesVodGenresStore();

export default defineNuxtRouteMiddleware(() => {
	if (import.meta.client) {
		setShowAllMovies();
	}
});